import { type CreateOrUpdateNotificationModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<
    Pick<CreateOrUpdateNotificationModel, 'name' | 'description'>
  >]: number
} = {
  name: 150,
  description: 1000,
}
